<template>
  <v-card class="mb-4">
    <v-card-title>
      Basic Information
    </v-card-title>
    <v-simple-table>

      <tbody>
      <tr>
        <td>
          Thumbnail
        </td>
        <td>
          <v-img :src="presentation.thumbnail.url"
                 width="260"
                 height="120"
                 contain
                 class="my-2"
                 alt="Thumbnail"/>
        </td>
      </tr>
      <tr>
        <td>
          Status
        </td>
        <td>
          <status-chip :status="presentation.status"
                       label
                       small>
          </status-chip>
        </td>
      </tr>
      <tr>
        <td>
          Type
        </td>
        <td>
          <presentation-icon :presentation="presentation">
          </presentation-icon>
          {{ presentation.presentation_type }}
        </td>
      </tr>
      <tr>
        <td>
          Size
        </td>
        <td>
          {{ presentation.size | filesize(2) }}
        </td>
      </tr>
      <tr v-if="presentation.external_id">
        <td>
          Asset ID
        </td>
        <td>
          {{ presentation.external_id }}
        </td>
      </tr>
      <tr>
        <td>
          Language
        </td>
        <td>
          {{ presentation.locale_name }}
        </td>
      </tr>
      <tr>
        <td>
          Asset ID
        </td>
        <td>
          <presentation-vault-icon v-if="team.uses_veeva_vault && presentation.vaultConfiguration"
                                   :presentation="presentation">
          </presentation-vault-icon>
          <template v-else>
            {{ presentation.external_id ? presentation.external_id : 'Not set' }}
          </template>
        </td>
      </tr>
      <tr>
        <td>
          Release Date
        </td>
        <td>
          <template v-if="presentation.release_at">
            {{ presentation.release_at | datetime('MMMM D, YYYY h:mm a') }}
          </template>
          <template v-else>
            Not set
          </template>
        </td>
      </tr>
      <tr>
        <td>
          Expiration Date
        </td>
        <td>
          <template v-if="presentation.expires_at">
            {{ presentation.expires_at | datetime('MMMM D, YYYY h:mm a') }}
          </template>
          <template v-else>
            Not set
          </template>
        </td>
      </tr>
      <tr v-if="reviewer">
        <td>
          Reviewer
        </td>
        <td>
          {{ reviewer.name }}
        </td>
      </tr>
      <tr>
        <td>
          Created
        </td>
        <td>
          {{ presentation.created_at | datetime('MMM D, YYYY h:mm a') }}
        </td>
      </tr>
      <tr>
        <td>
          Updated
        </td>
        <td>
          {{ presentation.updated_at | datetime('MMM D, YYYY h:mm a') }}
        </td>
      </tr>
      <tr>
        <td>
          Last Accessed
        </td>
        <td>
          <template v-if="presentation.last_accessed_at">
            {{ presentation.last_accessed_at | datetime('MMMM D, YYYY h:mm a') }}
          </template>
          <template v-else>
            Never
          </template>
        </td>
      </tr>
      <tr v-if="presentation.description">
        <td>
          Description
        </td>
        <td>
          {{ presentation.description }}
        </td>
      </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import PresentationIcon from './PresentationIcon';
import find from 'lodash/find';
import PresentationVaultIcon from '../../veeva_vault/components/PresentationVaultIcon';

export default {
  components: {PresentationVaultIcon, PresentationIcon},
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    reviewer() {
      if (this.presentation.reviewer_id) {
        return find(this.users, u => u.id === this.presentation.reviewer_id);
      }
      return null;
    },
    showPublishing() {
      return this.team.publish_enabled;
    }
  }
}
</script>
